import { User } from "@madhive/mad-sdk";
import { MadTracker } from "@madhive/mad-tracker";

let madTracker: MadTracker<User, { [k in string]: string }> | undefined;
let shouldUseMadTracker = false;

/**
 * Sets the MadTracker instance to be used by the useMadTracker hook.
 * This is useful for providing a custom implementation of MadTracker.
 */
export const setMadTracker = (
  tracker: MadTracker<User, { [k in string]: string }>
) => {
  if (madTracker) {
    console.warn(
      "MadTracker instance already set. Ignoring new instance and keeping existing one."
    );
    return;
  }
  shouldUseMadTracker = true;
  madTracker = tracker;
};

/**
 * Returns the current MadTracker instance.
 * @throws Error if `setMadTracker` has been called, but no instance has been set.
 */
export const useMadTracker = () => {
  if (shouldUseMadTracker && !madTracker) {
    throw new Error(
      "MadTracker instance not set. Please call setMadTracker before using useMadTracker."
    );
  }
  return madTracker;
};

export const __test__ = {
  /**
   * Removes the current MadTracker instance.
   * This meant for resetting between tests.
   */
  removeMadTrackerInstance: () => {
    madTracker = undefined;
    shouldUseMadTracker = false;
  }
};
